<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="true"
      :search-btn-hide="true"
      is-list
      :right-toolbar-hide="true"
      @afterFetchOriginalData="afterFetchOriginalData"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <el-switch
              v-else-if="col.prop === 'isEnable'"
              v-model="scope.row[col.prop]"
            ></el-switch>
            <el-tag
                v-else-if="col.prop === 'enableFlag'"
                :type="scope.row[col.prop] ? 'success' : 'info'"
                >{{ $t(STATUS_ENABLED_TRUE.bjGet(scope.row[col.prop])) }}</el-tag
              >
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template>
              <el-button
                disabled
                type="text"
                class="edit-btn"
                >{{ $t('editText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <div class="footer">
          <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="handleConfirm">{{ $t('saveText') }}</el-button>
    </div>
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin';
import pageMiXin from '@/utils/page-mixin.js';
import {channelApi, logisticApi} from '@/api';
import { STATUS_ENABLED_TRUE } from '@/utils/constants';

export default {
  name: 'BusinessChannelOnlineFlowDistributionCsg',
  mixins: [pageMiXin, viewMiXin],
  data() {
    return {
      STATUS_ENABLED_TRUE,
      colSpan: 6,
      selection: false,
      queryApi: logisticApi.getLogisticsBusiness,
      // 查询参数
      queryParams: { enableFlag: true, size: 999, _hasContent: 'hasContent' },
      dialogVisible: false,
      labelList: [
        { label: 'businessLogisticsCompany.table.status', prop: 'isEnable', isCheck: true, disabled: false },
        { label: this.$t('businessLogisticsCompanyList.status'), prop: 'enableFlag', isCheck: true, disabled: false },
        { label: 'businessLogisticsCompanyBusiness.table.name', prop: 'name', isCheck: true, disabled: false },
        { label: 'businessLogisticsCompany.table.logisticsCompanyName', prop: 'companyName', isCheck: true, disabled: false },
        // { label: 'businessLogisticsCompany.table.action', prop: 'bjTableAction', isCheck: true, disabled: false },
      ],
      tableData: [],
      configData: [],
      shopId: this.$route.query.shopId,
      shopCode: this.$route.query.shopCode
    };
  },
  computed: {},
  watch: {},
  methods: {
    afterFetchOriginalData(e) {
      e.forEach(item => {
        this.$set(item, 'isEnable', false);
      });
      this.tableData = e;

      this.getLogisticsConfigByShopCode().then(res => {
        if (res.length > 0) {
          e.forEach(item => {
            res.forEach(item2 => {
              if (item.code === item2.logisticsCode) {
                item.isEnable = !!item2.isEnable;
              }
            });
          });
        }
      });
      this.$nextTick(() => {
        this.tableData = e;
      });
    },
    // 根据网店code获取网店物流配置列表
    getLogisticsConfigByShopCode() {
      return new Promise(resolve => {
        channelApi.getLogisticsConfigByShopCode({ shopCode: this.shopCode }).then(res => {
          this.configData = res;
          resolve(res);
          });
        });
    },
    //  数据处理
    dataPrecossing(arr1, arr2) {
     const data = [];
     arr2.forEach(item2 => {
       const item1 = arr1.find(item1 => item1.logisticsCode === item2.code);
       if (item1) {
         data.push({
           ...item1,
           isEnable: item2.isEnable
         });
       } else {
         data.push({
           shopId: this.shopId,
           shopCode: this.shopCode,
           isEnable: item2.isEnable,
           logisticsId: item2.companyId,
           logisticsCode: item2.code,
           logisticsName: item2.name
         });
       }
     });
     return data;
    },

    handleConfirm() {
      let data = [];
      if (this.configData.length === 0) {
        this.tableData.forEach(item => {
            data.push({
              shopId: this.shopId,
              shopCode: this.shopCode,
              isEnable: item.isEnable,
              logisticsId: item.companyId,
              logisticsCode: item.code,
              logisticsName: item.name
            });
         });
      } else {
       data = this.dataPrecossing(this.configData, this.tableData);
      }
      if (!data.length) return;
      channelApi.updateBatchLogisticsConfig(data).then(res => {
        if (!res.failed) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.footer button {
    width: 200px;
  }
</style>
